module.exports = "<app-resource-view\r\n[resources]=\"resources\"\r\n\r\n></app-resource-view>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Projects/ePlanner Maintenance/src/app/controllers/resource/resource.component.html
// module id = ../../../../../src/app/controllers/resource/resource.component.html
// module chunks = main